import {
  FC,
  HTMLProps,
  SyntheticEvent,
  useLayoutEffect,
  useRef,
  useState,
} from 'react'
import classNames from 'classnames'
import {CloseIcon} from '../SvgIcon'
import {RenderIf} from '../RenderIf'

interface InputWithCloseProps {
  name: string
  handleClose: () => void
  inputProps: HTMLProps<HTMLInputElement>
  loading?: boolean
  width?: string
}

const noOperation = (e: SyntheticEvent): void => {
  e.preventDefault()
}

export const InputWithClose: FC<InputWithCloseProps> = ({
  name,
  handleClose,
  inputProps,
  loading = false,
  width = 'w-80',
}) => {
  const [inputWidth, setInputWidth] = useState<number>(0)
  const inputSpanRef = useRef<HTMLSpanElement>(null)
  const inputRef = useRef<HTMLInputElement>(null)

  const {value} = inputProps

  useLayoutEffect(() => {
    const newWidth = inputSpanRef?.current?.offsetWidth ?? 0
    if (newWidth !== inputWidth) {
      setInputWidth(newWidth)
    }
  }, [value, inputWidth])

  return (
    <div className="flex relative">
      <form id={`${name}-input-form`} onSubmit={noOperation}>
        <div
          className={classNames('flex flex-row items-center', {
            [width]: !value,
          })}
        >
          <span
            ref={inputSpanRef}
            data-cy={`${name}-input-span`}
            className="absolute abc-light text-2xl opacity-0 whitespace-pre pointer-events-none"
            onClick={() => {
              inputRef?.current?.focus()
            }}
          >
            {value}
          </span>
          <input
            id={`${name}-input`}
            ref={inputRef}
            type="text"
            className={classNames(
              'flex flex-1 bg-transparent abc-light text-2xl max-w-lg focus:outline-none placeholder-gray-1100 truncate',
            )}
            autoComplete="off"
            autoFocus
            data-cy={`${name}-input`}
            style={{width: inputWidth + 4}}
            {...inputProps}
          />
          <button hidden type="submit" id={`${name}-input-submit`} />
        </div>
      </form>
      <RenderIf isTrue={!loading}>
        <button
          data-cy={`${name}-input-close`}
          className="cursor-pointer"
          onClick={handleClose}
        >
          <CloseIcon />
        </button>
      </RenderIf>
    </div>
  )
}
